module.exports = __webpack_public_path__ + "static/img/img.c78a96ad.png";